const en = {
	license: {
		LicenseAgent: 'License Agent List',
		onLineActivate: 'Online Activate',
		offLineActivate: 'Offline Activate',
		plan: 'Plan',
		SerialNumberList: 'Serial Number',
		ExpirationTime: 'Expiration Time',
		EffictiveTime: 'Effictive Time',
		viewClientID: 'View HWID',
		Description: 'Description',
		deactivate: 'Deactivate',
		sortFile: 'Drag and drop the file here or manually select',
		selectFile: 'Select file',
		DelteteTip: 'Are you sure you want to deactivate the license?',
		Status: 'Status',
		MicroFrameManage: 'Microservice Framework Management',
		License: 'License',
		Service: 'Service',
		LicenseList: 'License List',
		Name: 'Name',
		CustomerName: 'Customer Name',
		Service: 'Service',
		HWID: 'HWID',
		Active_Deactive: 'Active/Deactive',
		Action: 'Action',
		AddLicense: 'Add License',
		required: 'required',
		Permanent: 'Permanent',
		Customname: 'Customname',
		Delete: 'Delete',
		Detail: 'Detail',
		BindedService: 'Binded Service',
		nodata: 'No Data'
	},
	service: {
		ServiceList: 'Service List',
		Name: 'Name',
		Version: 'Version',
		Checksum: 'Checksum',
		Description: 'Description',
		Action: 'Action',
		VersionHistory: 'Version History',
		required: 'required',
		Delete: 'Delete',
		DeleteTip: 'Are you sure you want to delete?',
		AddService: 'Add Service',
		EditService: 'Edit Service',
		Plan: 'Plan'
	}
}

export default en


// WEBPACK FOOTER //
// ./src/js/i18n/en.js